import {Language} from "../../views/types";

const en = {
    onlineCheckin: "Online Checkin: ",
    contactInfoDescTitle1: "Please make sure we have the most up-to-date profile, contact and insurance information so you can:",
    contactInfoDescS1: "Receive prompt communication",
    contactInfoDescS2: "Get hassle free payment process",
    contactInfoDescS3: "Reduce appointment waiting time",
    phoneNumber: "Phone Number:",
    emailAddress: "Email Address:",
    contactInfoTitle2: "Is your profile, contact and insurance information up-to-date?",
    yes: "Yes",
    no: "No",
    back: "Back",
    continue: "Continue",
    checkIn: "Check-in",
    helpVerify: "Help us verify it's you.",
    birthdayDesc: "Please enter your birthday below, so we can link the right profile for you and keep it secure.",
    dateOfBirth: "Date of Birth",
    pleaseFillField: "Please fill in this field",
    steps: (idx: number) => {
        return `Step ${idx} of 3: `
    },
    profileInfo: "Profile Information",
    takeMomentsDesc: "Please take a momement to fill out the form before your visit to shorten your wait time. Thanks!",
    name: "Name",
    firstName: "First Name",
    lastName: "Last Name",
    contactClinicInfo: "Please contact the clinic if any of the above info has changed.",
    race: "Race",
    ethnicity: "Ethnicity",
    martialStatus: "Martial Status",
    gender: "Gender",
    email: "Email",
    preferredLanguage: "Preferred Language",
    notificationPreferences: "Notification Preferences",
    address: "Address",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    city: "City",
    state: "State",
    insurance: "Insurance",
    skipInsurance: "Skip insurance for now.",
    frontCardInsurance: "Front of your Insurance Card",
    backCardInsurance: "Back of your Insurance Card",
    takePhoto: "Take Photo",
    errMsgRequired: (t: string) => {
        return `${t} is required`
    },
    verifyFailed1: "Sorry, we were’t able to verify your identity in our system.",
    verifyFailed2: " Please give us a call at ",
    verifyFailed3: " to learn more information.",
    consentForms: "Consent Forms",
    consentFormsDesc: "Please take a movement to fill out the form before your visit to shorten your wait time. Thanks!",
    signature: "Signature",
    clear: "Clear",
    signatureDesc: "By signing the name, I affirm that all the answers to questions and information herein are correct.",
    completeCheckIn: "Complete Check-in",
    selectYourAnswer: "Please select your answer",
    emailInvalid: "Please enter a valid email address.",
    zipCode: "Zip/Postal Code",
    mobilePhone: "Phone Number",
    select: "-- Select --",
    linkIsInvalid: "Link is invalid",
    loading: "Loading...",
}

const zh = {
    onlineCheckin: "在线报到:",
    contactInfoDescTitle1: "请确保我们拥有最新的个人资料、联系方式和保险信息，以便您可以: ",
    contactInfoDescS1: "获得及时的沟通",
    contactInfoDescS2: "获得无忧的付款过程",
    contactInfoDescS3: "减少预约等待时间",
    phoneNumber: "电话号码:",
    emailAddress: "电子邮件地址: ",
    contactInfoTitle2: "你的资料、联系人和保险信息是最新的吗？",
    yes: "是",
    no: "否",
    back: "返回",
    continue: "继续",
    checkIn: "Check-in",
    helpVerify: "帮助我们验证这是你,",
    birthdayDesc: "请在下面输入你的生日，这样我们就可以为你链接正确的资料，并保证其安全性",
    dateOfBirth: "出生日期",
    pleaseFillField: "请填写这个字段",
    steps: (idx: number) => {
        return `步骤${idx}/3: `
    },
    profileInfo: "个人资料信息",
    takeMomentsDesc: "请在访问前花点时间填写表格，以缩短您的等待时间,谢谢！",
    name: "姓名",
    firstName: "名",
    lastName: "姓氏",
    contactClinicInfo: "如果上述信息有任何变化，请联系诊所",
    race: "种族",
    ethnicity: "民族",
    martialStatus: "婚姻状态",
    gender: "性别",
    email: "电子邮件",
    preferredLanguage: "首选语言",
    notificationPreferences: "通知偏好",
    address: "地址",
    addressLine1: "地址线1",
    addressLine2: "地址行2",
    city: "城市",
    state: "州",
    insurance: "保险",
    skipInsurance: "暂时跳过保险",
    frontCardInsurance: "你的保险卡的正面",
    backCardInsurance: "你的保险卡的背面",
    takePhoto: "拍摄照片",
    errMsgRequired: (t: string) => {
        return `${t}是必需的`
    },
    verifyFailed1: "对不起，我们无法在我们的系统中验证您的身份,",
    verifyFailed2: "请给我们打电话，",
    verifyFailed3: "以了解更多信息,",
    consentForms: "同意书",
    consentFormsDesc: "请您在就诊前花点时间填写表格，以缩短您的等待时间,谢谢！",
    signature: "签名",
    clear: "清除",
    signatureDesc: "通过签署名字，我确认这里的所有问题和信息的答案都是正确的。",
    completeCheckIn: "完成报到",
    selectYourAnswer: "请选择您的答案",
    emailInvalid: "请输入一个有效的电子邮件地址,",
    zipCode: "门牌号",
    mobilePhone: "手机号码",
    select: "-- 选择 --",
    linkIsInvalid: "该连接无效",
    loading: "加载中...",
}

const esp = {
    onlineCheckin: "Registro en línea: ",
    contactInfoDescTitle1: "Por favor, asegúrese de que tenemos la información de perfil, contacto y seguro más actualizada para que pueda:",
    contactInfoDescS1: "Recibir una comunicación rápida",
    contactInfoDescS2: "Obtener un proceso de pago sin complicaciones",
    contactInfoDescS3: "Reducir el tiempo de espera de las citas",
    phoneNumber: "Número de teléfono:",
    emailAddress: "Dirección de correo electrónico:",
    contactInfoTitle2: "¿Está actualizada su información de perfil, contacto y seguro?",
    yes: "Sí",
    no: "No",
    back: "Atrás",
    continue: "Continuar",
    checkIn: "Check-in",
    helpVerify: "Ayúdanos a verificar que eres tú",
    birthdayDesc: "Introduce tu fecha de nacimiento a continuación para que podamos vincular el perfil adecuado para ti y mantenerlo seguro",
    dateOfBirth: "Fecha de nacimiento",
    pleaseFillField: "Por favor, rellena este campo",
    steps: (idx: number) => {
        return `Paso ${idx} de 3: `
    },
    profileInfo: "Información del perfil",
    takeMomentsDesc: "Por favor, tómese un momento para rellenar el formulario antes de su visita para acortar el tiempo de espera. Gracias",
    name: "Nombre",
    firstName: "Nombre",
    lastName: "Apellido",
    contactClinicInfo: "Póngase en contacto con la clínica si alguno de los datos anteriores ha cambiado",
    race: "Raza",
    ethnicity: "etnia",
    martialStatus: "estado marcial",
    gender: "Género",
    email: "Correo electrónico",
    preferredLanguage: "Idioma preferido",
    notificationPreferences: "Preferencias de notificación",
    address: "Dirección",
    addressLine1: "Línea de dirección 1",
    addressLine2: "Línea de dirección 2",
    city: "Ciudad",
    state: "Estado",
    insurance: "Seguro",
    skipInsurance: "Saltar seguro por ahora",
    frontCardInsurance: "Anverso de tu tarjeta de seguro",
    backCardInsurance: "Reverso de su tarjeta de seguro",
    takePhoto: "Hazte una foto",
    errMsgRequired: (t: string) => {
        return `${t} es requerido`
    },
    verifyFailed1: "Lo sentimos, no hemos podido verificar su identidad en nuestro sistema",
    verifyFailed2: " Por favor, llámenos al ",
    verifyFailed3: " para obtener más información",
    consentForms: "Formularios de consentimiento",
    consentFormsDesc: "Por favor, rellene el formulario antes de su visita para acortar el tiempo de espera. Gracias!",
    signature: "Firma",
    clear: "Borrar",
    signatureDesc: "Al firmar, afirmo que todas las respuestas a las preguntas y la información aquí contenida son correctas",
    completeCheckIn: "Registro completo",
    selectYourAnswer: "Por favor, seleccione su respuesta",
    emailInvalid: "Por favor, introduzca una dirección de correo electrónico válida",
    zipCode: "Código postal",
    mobilePhone: "Número de teléfono",
    select: "-- Seleccionar --",
    linkIsInvalid: "El enlace no es válido ",
    loading: "Loading...",
}

export const LangManager = (lange: Language) => {
    switch (lange) {
    case Language.en:
        return en;
    case Language.zh:
        return zh;
    case Language.sp:
        return esp
    default:
        return en
    }
}
